/* eslint-disable class-methods-use-this */
import {
  ImpersonatedResult,
  ImpersonateOutput,
  ImpersonateTenantInput,
} from 'services/tenant/dto/impresonation';
import http from '../httpService';
import { IsTenantAvaibleInput } from './dto/isTenantAvailableInput';
import IsTenantAvaibleOutput from './dto/isTenantAvailableOutput';
import { ForgotPasswordInput, RegisterInput, ResetPasswordInput } from './dto/registerInput';
import { RegisterOutput } from './dto/registerOutput';

class AccountService {
  public async isTenantAvailable(
    isTenantAvaibleInput: IsTenantAvaibleInput
  ): Promise<IsTenantAvaibleOutput> {
    const result = await http.post(
      'api/services/app/Account/IsTenantAvailable',
      isTenantAvaibleInput
    );
    return result.data.result;
  }

  public async register(registerInput: RegisterInput): Promise<RegisterOutput> {
    const result = await http.post('api/services/app/Account/Register', registerInput);
    return result.data.result;
  }

  public async sendPasswordResetCode(input: ForgotPasswordInput) {
    await http.post('api/services/app/Account/SendPasswordResetCode', input);
  }

  public async resetPassword(input: ResetPasswordInput) {
    await http.post('api/services/app/Account/ResetPassword', input);
  }

  public async impersonateTenantToken(input: ImpersonateTenantInput): Promise<ImpersonateOutput> {
    const response = await http.post('api/services/app/Account/ImpersonateTenant', input);
    return response.data.result;
  }

  public async backToImpersonator(): Promise<ImpersonateOutput> {
    const response = await http.post('api/services/app/Account/BackToImpersonator');
    return response.data.result;
  }

  public async impersonateLogin(impersonationToken: string): Promise<ImpersonatedResult> {
    const response = await http.post(
      `api/TokenAuth/ImpersonatedAuthenticate?impersonationToken=${impersonationToken}`
    );
    return response.data.result;
  }

  public async sendEmailActivationLink(input: { emailAddress: string }): Promise<void> {
    await http.post('api/services/app/Account/SendEmailActivationLink', input);
  }
}

export default new AccountService();
